"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
var kendo_react_intl_1 = require("@progress/kendo-react-intl");
var messages_1 = require("../messages");
var logicData = [{ text: messages_1.columnMenuFilterAndLogic, logic: 'and' }, { text: messages_1.columnMenuFilterOrLogic, logic: 'or' }];
exports.ColumnMenuFilterLogic = function (props) {
    var localization = kendo_react_intl_1.useLocalization();
    var data = (props.data || logicData)
        .map(function (i) { return (__assign({}, i, { text: localization.toLanguageString(i.text, messages_1.messages[i.text]) })); });
    return (React.createElement(kendo_react_dropdowns_1.DropDownList, __assign({ onChange: props.onChange, className: "k-filter-and", textField: "text" }, props, { data: data, value: data.find(function (i) { return i.logic === props.value; }) })));
};
//# sourceMappingURL=ColumnMenuFilterLogic.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/columnmenu/ColumnMenuFilterLogic.js
// module id = 293
// module chunks = 0